/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum StatutCommandes {
  CcNonPayee = 'CC_NON_PAYEE',
  CcPayeeEnAttente = 'CC_PAYEE_EN_ATTENTE',
  CcPayeeEnPreparation = 'CC_PAYEE_EN_PREPARATION',
  CcPayeePreparee = 'CC_PAYEE_PREPAREE',
  CcPayeeLivree = 'CC_PAYEE_LIVREE',
  CcPayeeAnnulee = 'CC_PAYEE_ANNULEE',
  CcPaiementAbandonne = 'CC_PAIEMENT_ABANDONNE',
  CcPaiementRefuse = 'CC_PAIEMENT_REFUSE',
  DtaNonPayee = 'DTA_NON_PAYEE',
  DtaPaiementRefuse = 'DTA_PAIEMENT_REFUSE',
  DtaPayeeCommandee = 'DTA_PAYEE_COMMANDEE',
  DtaPayeeDisponible = 'DTA_PAYEE_DISPONIBLE',
  DtaPayeeNonRetiree = 'DTA_PAYEE_NON_RETIREE',
  DtaPayeeRetiree = 'DTA_PAYEE_RETIREE',
  DtaPayeeAnnulee = 'DTA_PAYEE_ANNULEE',
  DtaPayeeErreurResaCasierPhysique = 'DTA_PAYEE_ERREUR_RESA_CASIER_PHYSIQUE',
  DtaPayeeResaCasierPhysiqueFaite = 'DTA_PAYEE_RESA_CASIER_PHYSIQUE_FAITE',
  DtaNonPayeeAbandonnee = 'DTA_NON_PAYEE_ABANDONNEE',
  ScorpNonPayee = 'SCORP_NON_PAYEE',
  ScorpAnnuleeConvive = 'SCORP_ANNULEE_CONVIVE',
  ScorpAnnuleeGerant = 'SCORP_ANNULEE_GERANT',
  ScorpReglee = 'SCORP_REGLEE',
  ScorpErreurReglement = 'SCORP_ERREUR_REGLEMENT',
  RsRecu = 'RS_RECU',
  RsEnCoursDeTraitement = 'RS_EN_COURS_DE_TRAITEMENT',
  RsLivree = 'RS_LIVREE',
  RsFacture = 'RS_FACTURE',
  RsAnnulee = 'RS_ANNULEE',
  RsDevis = 'RS_DEVIS',
  RsDevisAnnule = 'RS_DEVIS_ANNULE',
}
